import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IPropertyPlanImage} from "../types/IPropertyPlanImage";

export const getPropertyPlanImages = (
    propertyPlanPages: {
        image: Pick<IPropertyPlanImage, "p_img_560" | "p_img_980" | "p_img_1500">;
        image_url?: string | null;
    }[]
) => {
    return propertyPlanPages.map(({image, image_url}) => ({
        srcSm: getThumbnailLink(image_url, 560) ?? image.p_img_560,
        srcMd: getThumbnailLink(image_url, 980) ?? image.p_img_980,
        srcLg: getThumbnailLink(image_url, 1500) ?? image.p_img_1500
    }));
};
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IPropertyPlanImage} from "../types/IPropertyPlanImage";

export const getPropertyPlanImages = (
    propertyPlanPages: {
        image: Pick<IPropertyPlanImage, "p_img_560" | "p_img_980" | "p_img_1500">;
        image_url?: string | null;
    }[]
) => {
    return propertyPlanPages.map(({image, image_url}) => ({
        srcSm: getThumbnailLink(image_url, 560) ?? image.p_img_560,
        srcMd: getThumbnailLink(image_url, 980) ?? image.p_img_980,
        srcLg: getThumbnailLink(image_url, 1500) ?? image.p_img_1500
    }));
};
